import { useContext } from "react";
import { AuthContext } from "@context/AuthProvider";
import { useBaseApiMutation } from "@mutation/baseMutation";

export const useLoginMutation = () => {
    const { setAccessToken, setRefreshToken } = useContext(AuthContext);

    return useBaseApiMutation({
        method: "POST",
        endpoint: "/auth/login/oauth2",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    }, {
        onSuccess: (response) => {
            setAccessToken(response.data.access_token);  
            // setAccessToken("for_testing");  
            setRefreshToken(response.data.refresh_token);  
        },
        onError: (error) => {
            console.error("Login failed:", error);
        },
    });
};

export const useLogoutMutation = () => {
    const { setAccessToken, accessToken, setRefreshToken, refreshToken } = useContext(AuthContext);

    return useBaseApiMutation({
        method: "POST",
        endpoint: "/auth/logout",
        data: {
            access_token: accessToken, 
            refresh_token: refreshToken
        }
    }, {
        onSuccess: () => {
            setAccessToken(null);  
            setRefreshToken(null); 
        },
        onError: (error) => {
            console.error("Logout failed:", error);
            setAccessToken(null);  
            setRefreshToken(null); 
        },
    });
};

export const useRefreshTokenMutation = () => {
    const { setAccessToken, setRefreshToken, refreshToken } = useContext(AuthContext);
    const logoutMutation = useLogoutMutation();

    return useBaseApiMutation({
        method: "POST",
        endpoint: "/auth/refresh-tokens",
        data: {
            refresh_token: refreshToken
        }
    }, {
        onSuccess: (response) => {
            setAccessToken(response.data.access_token);
            setRefreshToken(response.data.refresh_token); 
        },
        onError: () => {
            logoutMutation.mutate();
        },
    });
};


export const useResetPasswordMutation = () => {
    return useBaseApiMutation({
        method: "POST",
        endpoint: "/auth/reset-password"
    }, {
        onSuccess: () => {
            console.log("Reset password OK");
        },
        onError: (error) => {
            console.error("Reset password failed:", error);
        },
    });
};


export const useVerifyResetPasswordCodeMutation = () => {
    return useBaseApiMutation({
        method: "GET",
        endpoint: "/auth/validate-password-reset-code/{code}"
    }, {
        onSuccess: () => {
            console.log("useVerifyResetPasswordCodeMutation OK");
        },
        onError: (error) => {
            console.error("useVerifyResetPasswordCodeMutation failed:", error);
        },
    });
};

export const useSetNewPasswordMutation = () => {
    return useBaseApiMutation({
        method: "POST",
        endpoint: "/auth/confirm-reset"
    }, {
        onSuccess: () => {
            console.log("useSetNewPasswordMutation OK");
        },
        onError: (error) => {
            console.error("useSetNewPasswordMutation failed:", error);
        },
    });
};

export const useConfirmRegistrationMutation = () => {
    return useBaseApiMutation({
        method: "POST",
        endpoint: "/auth/confirm-registration"
    }, {
        onSuccess: () => {
            console.log("useConfirmRegistrationMutation OK");
        },
        onError: (error) => {
            console.error("useConfirmRegistrationMutation failed:", error);
        },
    });
};